import { useEffect, useRef } from "react";
import { adsEnabled, isAdsAllowedPath, loadAdSenseOnce, pushAd, ADS_CLIENT } from "@/lib/adsense";

const SLOT_RE = /^\d+$/;

// Responsive display ad. Renders nothing (no reserved gap) unless ads are
// enabled, the slot is valid and the current route is an allowed SFW page.
export function AdUnit({ slot, className = "", label = true }) {
  const ref = useRef(null);
  const canLoad = adsEnabled && isAdsAllowedPath();          // load script (enables Auto Ads)
  const canRender = canLoad && SLOT_RE.test(slot || "");     // render a manual unit

  useEffect(() => {
    if (!canLoad) return;
    loadAdSenseOnce();
    if (canRender) pushAd(ref.current);
  }, [canLoad, canRender, slot]);

  if (!canRender) return null;

  return (
    <div className={`w-full my-6 ${className}`} data-testid="ad-unit">
      {label && <p className="text-[10px] uppercase tracking-widest text-muted-foreground/50 text-center mb-1">Advertisement</p>}
      <ins
        ref={ref}
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={ADS_CLIENT}
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}
